"use client";
import Link from "next/link";
import { useRouter } from "next/navigation"; // Import Next.js router
import React, { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import DemoButton from "../Demo/DemoButton";
import logo1 from "@/Helper/images/logo.png";
import logo2Blue from "@/Helper/images/new/logoblue.svg";
import Image from "next/image";
import CancelIcon from "@mui/icons-material/Cancel";
import Drawer from "@mui/material/Drawer";

const BurgerMenu = ({ pathname = "/" }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [drawerType, setDrawerType] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const router = useRouter(); // Initialize router

  // Handle opening and closing the main menu
  const handleStateChange = (state) => {
    setMenuOpen(state.isOpen);
  };

  // Toggle drawer for Products or Resources
  const toggleDrawer = (type) => {
    if (isDrawerOpen && drawerType === type) {
      closeDrawer();
    } else {
      setDrawerType(type);
      setIsDrawerOpen(true);
    }
  };

  // Close only the drawer (not the main menu)
  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setDrawerType(null);
  };

  // Close all menus and navigate smoothly using Next.js router
  const handleCloseAndNavigate = (href) => {
    closeDrawer(); // Close all drawers
    setMenuOpen(false); // Close main menu
    setTimeout(() => {
      router.push(href); // Navigate using Next.js router
    }, 200);
  };

  // Products Dropdown Content
  const ProductsDropdown = () => (
    <ul className="nav_subul mobile_subnav">
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/custom-shaft-design")}>
          <span className={pathname.includes("/custom-shaft-design") ? "currentPage" : ""}>
            Custom Shaft Designs
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/standard-flexible-shaft")}>
          <span className={pathname.includes("/standard-flexible-shaft") ? "currentPage" : ""}>
            Standard Flexible Shaft
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/ready-flex-product-line")}>
          <span className={pathname.includes("/ready-flex-product-line") ? "currentPage" : ""}>
            Ready-flex product listmenu
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/ready-flex-configurator")}>
          <span className={pathname.includes("/ready-flex-configurator") ? "currentPage" : ""}>
            Ready-flex configurator
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/gear-boxes")}>
          <span className={pathname.includes("/gear-boxes") ? "currentPage" : ""}>
          Gear boxes
          </span>
        </p>
      </li>
    </ul>
  );
  // Solutions Dropdown content

  const SolutionsDropdown = () => (
    <ul className="nav_subul mobile_subnav">
      {/* <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/applications")}>
          <span className={pathname.includes("/applications") ? "currentPage" : ""}>
          Applications
          </span>
        </p>
      </li> */}

      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/aerospace")}>
          <span className={pathname.includes("/aerospace") ? "currentPage" : ""}>
          Aerospace
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/automotive")}>
          <span className={pathname.includes("/automotive") ? "currentPage" : ""}>
          Automotive
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/medical")}>
          <span className={pathname.includes("/medical") ? "currentPage" : ""}>
          Medical
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/industrial")}>
          <span className={pathname.includes("/industrial   ") ? "currentPage" : ""}>
          Industrial
          </span>
        </p>
      </li>
     
    </ul>
  );


  // Resources Dropdown Content
  const ResourcesDropdown = () => (
    <ul className="nav_subul mobile_subnav">
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/blog")}>
          <span className={pathname.includes("/blog") ? "currentPage" : ""}>Blog</span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/technical")}>
          <span className={pathname.includes("/technical") ? "currentPage" : ""}>Technical</span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/use-cases")}>
          <span className={pathname.includes("/use-cases") ? "currentPage" : ""}>Use Case</span>
        </p>
      </li>
    </ul>
  );

 const AboutUsDropdown = () => (
    <ul className="nav_subul mobile_subnav">
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/about-us")}>
          <span className={pathname.includes("/about-us") ? "currentPage" : ""}>
          About Us
          </span>
        </p>
      </li>

      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/quality")}>
          <span className={pathname.includes("/quality") ? "currentPage" : ""}>
          Quality
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/gallery")}>
          <span className={pathname.includes("/gallery") ? "currentPage" : ""}>
          Gallery
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/team")}>
          <span className={pathname.includes("/team") ? "currentPage" : ""}>
          Team
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/history")}>
          <span className={pathname.includes("/history   ") ? "currentPage" : ""}>
          History
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/testimonials")}>
          <span className={pathname.includes("/testimonials   ") ? "currentPage" : ""}>
          Testimonials
          </span>
        </p>
      </li>
      <li>
        <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/careers")}>
          <span className={pathname.includes("/careers   ") ? "currentPage" : ""}>
          Careers
          </span>
        </p>
      </li>
     
    </ul>
  );

  return (
    <>
      <div className="menuburgerlist">
        <Menu
          left
          isOpen={isMenuOpen}
          onStateChange={handleStateChange}
          customCrossIcon={<CloseIcon sx={{ color: "#002E5D" }} />}
          customBurgerIcon={<MenuIcon sx={{ color: "#fff" }} />}
          className="bm-item-listout"
        >
          {/* Sidebar Content */}
          <div className="listmenu">
            {/* Header with Logo & Close Button */}
            <div className="burgerhead">
              <Image src={logo2Blue} alt="logo" className="nav_logo" onClick={() => handleCloseAndNavigate("/")} />
              <CancelIcon onClick={() => setMenuOpen(false)} />
            </div>

            {/* Navigation Links */}
            <div className="nav_container_right">
              <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/")}>
                <span className={pathname === "/" ? "currentPage" : ""}>Home</span>
              </p>

              {/* Products - Opens Drawer */}
              <div className="navbar_mobile withsubmenunav">
                <span
                  onClick={() => toggleDrawer("products")}
                  className={`mainspan ${pathname.includes("/products") ? "currentPage" : ""}`}
                >
                  Products
                </span>
              </div>
              
              <div className="navbar_mobile withsubmenunav">
                <span
                  onClick={() => toggleDrawer("solutions")}
                  className={`mainspan ${pathname.includes("/solutions") ? "currentPage" : ""}`}
                >
                 Applications
                </span>
              </div>



              {/* Resources - Opens Drawer */}
              <div className="navbar_mobile withsubmenunav">
                <span
                  onClick={() => toggleDrawer("resources")}
                  className={`mainspan ${pathname.includes("/resources") ? "currentPage" : ""}`}
                >
                  Resources
                </span>
              </div>
              <div className="navbar_mobile withsubmenunav">
                <span
                  onClick={() => toggleDrawer("aboutus")}
                  className={`mainspan ${pathname.includes("/About Us") ? "currentPage" : ""}`}
                >
                  About Us
                </span>
              </div>
              <p className="navbar_mobile" onClick={() => handleCloseAndNavigate("/contact-us")}>
                <span className={pathname === "/contact-us" ? "currentPage" : ""}>Contact Us</span>
              </p>
              
            </div>
          </div>

          {/* Demo Button */}
          {/* <DemoButton navBar aria-hidden="true" /> */}
        </Menu>
      </div>

      {/* Drawer for Products & Resources */}
      <Drawer anchor="left" open={isDrawerOpen} onClose={closeDrawer} className="dropdownburger">
        <div className="listmenu">
          <div className="burgerhead burgerheadsubmenu">
            <Image src={logo2Blue} alt="logo" className="nav_logo" onClick={() => handleCloseAndNavigate("/")} />
            <CancelIcon onClick={closeDrawer} /> {/* Only closes this drawer */}
          </div>
          

          {/* Conditionally Render Products or Resources */}
          {drawerType === "products" && ProductsDropdown()}
          {drawerType === "resources" && ResourcesDropdown()}
          {drawerType === "solutions" && SolutionsDropdown()}
          {drawerType === "aboutus" && AboutUsDropdown()}
        </div>
      </Drawer>
    </>
  );
};

export default BurgerMenu;
